import { __exports as ExitToAppOutlined } from '../../../_virtual/ExitToAppOutlined.esm.js';
import { i as interopRequireDefaultExports } from '../../@babel/runtime/helpers/interopRequireDefault.esm.js';
import { __require as requireCreateSvgIcon } from './utils/createSvgIcon.esm.js';
import require$$2 from 'react/jsx-runtime';

var _interopRequireDefault = interopRequireDefaultExports;
Object.defineProperty(ExitToAppOutlined, "__esModule", {
  value: true
});
var default_1 = ExitToAppOutlined.default = void 0;
var _createSvgIcon = _interopRequireDefault(requireCreateSvgIcon());
var _jsxRuntime = require$$2;
var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M10.09 15.59 11.5 17l5-5-5-5-1.41 1.41L12.67 11H3v2h9.67l-2.58 2.59zM19 3H5c-1.11 0-2 .9-2 2v4h2V5h14v14H5v-4H3v4c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
}), 'ExitToAppOutlined');
default_1 = ExitToAppOutlined.default = _default;

export { default_1 as default };
